import { render } from "./IconMeli.vue?vue&type=template&id=ed2da688"
import script from "./IconMeli.vue?vue&type=script&lang=js"
export * from "./IconMeli.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__